import { catchError, filter, mergeMap, of } from 'rxjs'
import type { AjaxError } from 'rxjs/ajax'
import type { Epic } from '../../../index.js'
import { organizationSlice } from '../../../Slice/Organization/OrganizationSlice.js'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'

export const UpdateOrganizationLogoEpic: Epic = (action$, state$, { [organizationSlice.name]: organization, OrganizationRepository }) =>
  action$.pipe(
    filter(organization.updateLogoRequest.match),
    mergeMap((action) => {
      return OrganizationRepository.updateOrganizationLogo({ logo: action.payload.logo }).pipe(
        mergeMap((response) => of(organization.updateLogoRequestSuccess({ orgId: action.payload.id, logoKey: response.key}))),
        catchError((error: AjaxError) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(organization.updateLogoRequestFailure({ error }))
          })
        )
      )
    })
  )
